<template>
  <div class="nearby-wrapper">
    <div class="top">
      <div class="distance">
        <svg class="flag-svg">
          <use xlink:href="#icon-flag"></use>
        </svg>
        {{ business.distance }}Km
      </div>
      <h3>
        {{ business.label }}
      </h3>
      <div class="hours-heading">
        {{ $t('commons.hours') }}
      </div>
      <div class="hours">
        {{ weekdaysTxt }}
        <br>
        {{ weekendsTxt }}
      </div>
      <basic-prompt
        class="phone-wrapper"
        :replace="true"
      >
        <template v-slot:visible>
          <div class="clickable-txt">
            <svg>
              <use xlink:href="#icon-phone"></use>
            </svg> Cliquer pour voir le téléphone
          </div>
        </template>
        <template v-slot:prompt>
          <div class="phone">
            Tél&nbsp;:{{ business.phone }}
          </div>
        </template>
      </basic-prompt>
    </div>
    <div class="bottom">
      <arrow-link
        :href="`/agences/${business.slug}`"
        :text=" $t('commons.details')"
      />
    </div>
  </div>
</template>
<script>
import businessHours from '../../../shared/mixins/businessHours';
import ArrowLink from '../../../shared/ArrowLink'
import BasicPrompt from '../../../shared/BasicPrompt'

export default {
  name: 'NearbyBusiness',
  mixins: [businessHours],
  props: {
    business: {
      type: Object,
      required: true,
    },
  },
  components: {
    BasicPrompt,
    ArrowLink,
  },
}
</script>
<style lang="scss" scoped>

.nearby-wrapper {
  border: solid 1px $c-silver;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 180px;
}

.top {
  height: 100%;
  padding: 15px 5px 0;
  position: relative;
}

.distance {
  @include font-size(19px);

  color: black;
  margin: 0 0 10px;
}

svg {
  height: 18px;
  width: 15px;
}

.flag-svg {
  height: 14px;
  width: 9px;
}

h3 {
  color: black;
  font-family: $f-graphie-bold;
  margin: 0 0 10px;
  text-transform: uppercase;

  @include font-size(11px);
}

.phone-wrapper {
  bottom: 5px;
  position: absolute;
}

.clickable-txt {
  align-items: center;
  display: flex;
  text-decoration: underline;
}

.clickable-txt,
.phone {
  color: black;

  @include font-size(11px);
}

.clickable-txt {
  align-items: center;
  color: black;
  display: flex;
  text-decoration: underline;

  @include font-size(11px);
}

.bottom {
  padding-left: 1rem;
}
</style>
